module.exports = __webpack_public_path__ + "img/muscle_guy_sil.8ac8464e.png";